import type { AxiosResponse } from 'axios'
import api from '../utils/api'
import {
  type ISisSyncRun,
  type ISisSyncRunFileListResponse,
  type ISisSyncRunListResponse,
  type SisSyncRunFileListParams,
  type SisSyncRunListParams
} from '../models/SisSyncRun'

const getSisSyncRuns = async (params?: SisSyncRunListParams): Promise<AxiosResponse<ISisSyncRunListResponse>> => {
  return await api.get('/api/sis_sync_runs/', {
    headers: {
      Accept: 'application/cdg'
    },
    params: {
      pageNumber: params?.pageNumber,
      pageSize: params?.pageSize,
      filters: params?.filters,
      sort: params?.sort
    }
  })
}

const getSisSyncRun = async (runId: string): Promise<AxiosResponse<ISisSyncRun>> => {
  // Bare run row: adding Accept: application/cdg would wrap it in a DataObject.
  return await api.get(`/api/sis_sync_runs/${runId}/`)
}

const getSisSyncRunFiles = async (runId: string, params?: SisSyncRunFileListParams): Promise<AxiosResponse<ISisSyncRunFileListResponse>> => {
  return await api.get(`/api/sis_sync_runs/${runId}/files/`, {
    headers: {
      Accept: 'application/cdg'
    },
    params: {
      pageNumber: params?.pageNumber,
      pageSize: params?.pageSize,
      search: params?.search,
      sort: params?.sort
    }
  })
}

export default {
  getSisSyncRuns,
  getSisSyncRun,
  getSisSyncRunFiles
}
